import { useLazyQuery } from '@apollo/client/react';
import { QUERY_DOG_NAMES } from '../../graphql/dog-queries';

export default function useGetDogNames() {
    const [getDogNames, { data, loading }] = useLazyQuery(QUERY_DOG_NAMES);
    return { getDogNames, data, loading };
}
